import deletePrice from "@custom/rtk-apis/price/deletePrice";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const deletePriceSlice = createSlice({
  name: "deletePriceSlice",
  initialState,
  reducers: {
    closePatientDeleteModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deletePrice.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deletePrice.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deletePrice.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deletePriceSlice.reducer;
export const { closePatientDeleteModal } = deletePriceSlice.actions;
